module.exports = __webpack_public_path__ + "img/mestre_simposios.d14efc10.png";